import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RBImage from "react-bootstrap/Image";
import { useEffect, useState } from "react";
import LoadingOverlay from "./loader/LoadingOverlay";
// import Pagination from 'react-bootstrap/Pagination';

const galleryData = [
  {
    id: 1,
    // link: '',
    image: require("../assets/images/buil1.jpg"),
    // title: 'Lonely Path',
    // subtitle: 'Web Design'
  },
  { id: 2, image: require("../assets/images/build.jpg") },
  { id: 3, image: require("../assets/images/ContactUs1.JPG") },
  { id: 4, image: require("../assets/images/pz7.jpg") },
  { id: 5, image: require("../assets/images/t1.jpg") },
  { id: 6, image: require("../assets/images/t2.jpg") },
  // { id: 12, image: require('../assets/images/lb1.jpg') },

  { id: 7, image: require("../assets/images/st4.jpg") },
  { id: 8, image: require("../assets/images/st9.jpg") },
  { id: 9, image: require("../assets/images/lib.jpg") },

  { id: 10, image: require("../assets/images/st1.jpg") },

  // { id: 13, image: require('../assets/images/lb2.jpg') },

  // { id: 6, image: require('../assets/images/st5.jpg') },
  { id: 11, image: require("../assets/images/st6.jpg") },
  // { id: 4, image: require('../assets/images/st3.jpg') },
  { id: 12, image: require("../assets/images/st8.jpg") },

  { id: 13, image: require("../assets/images/st10.jpg") },
  { id: 14, image: require("../assets/images/pz3.jpg") },
  { id: 27, image: require("../assets/images/award.JPG") },

  { id: 15, image: require("../assets/images/pz1.jpg") },
  { id: 16, image: require("../assets/images/pz2.jpg") },

  { id: 17, image: require("../assets/images/pz5.jpg") },
  { id: 18, image: require("../assets/images/sports.jpg") },
  { id: 19, image: require("../assets/images/sports2.jpg") },
  { id: 20, image: require("../assets/images/sport2.jpg") },
  // { id: 18, image: require('../assets/images/pz6.jpg') },

  { id: 22, image: require("../assets/images/child.JPG") },
  { id: 23, image: require("../assets/images/child2.JPG") },
  { id: 24, image: require("../assets/images/child3.JPG") },
  { id: 25, image: require("../assets/images/bus.JPG") },
  { id: 26, image: require("../assets/images/bus2.JPG") },
  // { id: 27, image: require('../assets/images/bus3.JPG') },
  { id: 21, image: require("../assets/images/st2.jpg") },
];

// let active = 2;
// let items = [];
// for (let number = 1; number <= 5; number++) {
//   items.push(
//     <Pagination.Item key={number} active={number === active}>
//       {number}
//     </Pagination.Item>,
//   );
// }

function Appgallery() {
  const [headerLoading, setHeaderLoading] = useState(true);
  const [loadedImages, setLoadedImages] = useState({});

  useEffect(() => {
    const img = new Image();
    img.src = require("../assets/images/gallery.png"); // or import path
    img.onload = () => setHeaderLoading(false);
    img.onerror = () => setHeaderLoading(false);
  }, []);

  const handleImageLoad = (id) => {
    setLoadedImages((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <div style={{ overflowX: "hidden" }}>
      <section id="gallery" className="block gallery-block">
        <div className="work-page">
          {/* HEADER */}
          <header className="position-relative">
            {headerLoading && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  zIndex: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LoadingOverlay overlayOnly />
              </div>
            )}
            <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light position-relative">
              <h1 className="text-center fw-semibold display-3">Gallery</h1>
              <p className="text-center w-75 mb-5 fs-4">
                Explore the vibrant life at Kanchan Vidya Mandir Sr. Sec. School
                through our gallery. From academic achievements to cultural
                events and sports activities, our gallery captures the memorable
                moments that shape our students' journey.
              </p>
            </div>
          </header>

          <Container fluid>
            <Row className="portfoliolist">
              {galleryData.map((gallery) => (
                <Col sm={4} key={gallery.id} className="mb-4">
                  <div className="portfolio-wrapper position-relative">
                    {!loadedImages[gallery.id] && (
                      <LoadingOverlay overlayOnly={true} />
                    )}
                    <RBImage
                      src={gallery.image}
                      onLoad={() => handleImageLoad(gallery.id)}
                      fluid
                      className="w-100"
                      style={{ minHeight: "250px", objectFit: "cover" }}
                    />
                    <div className="label text-center">
                      <h3>{gallery.title}</h3>
                      <p>{gallery.subtitle}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </div>
      </section>
    </div>
  );
}

export default Appgallery;
